import {Controller} from "@hotwired/stimulus"
import wNumb from 'wnumb';
import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default class extends Controller {
    static targets = ["priceSlider", "rangeText", "kwhSlider", "kwhText", "battVolts"];

    connect() {
        noUiSlider.create(this.priceSliderTarget, {
            start: [0, 50000],
            step: 100,
            connect: true,
            range: {
                'min': 0,
                'max': 50000
            },
            format: wNumb({
                decimals: 0
            })
        });

        noUiSlider.create(this.kwhSliderTarget, {
            start: [0, 50],
            step: 1,
            connect: true,
            range: {
                'min': 0,
                'max': 50
            },
            format: wNumb({
                decimals: 0
            })
        });
    }

    priceSlide(event) {
        let handles = event.target.closest(".slider").noUiSlider.get();
        let fromHandle =  parseFloat(handles[0])
        let toHandle = parseFloat(handles[1])
        let rows = Array.from(document.getElementsByClassName("product-row"));

        rows.forEach((row) =>  {
            let price = parseFloat(row.dataset.price);

            if (price >= fromHandle && price <= toHandle) {
                row.style.display = "";
            } else {
                row.style.display = "none";
            }
        });

        this.rangeTextTarget.innerHTML = `$${handles[0]} - $${handles[1]}`;
    }

    kwhSlide(event) {
        let handles = event.target.closest(".slider").noUiSlider.get();
        let fromHandle =  parseFloat(handles[0])
        let toHandle = parseFloat(handles[1])
        let rows = Array.from(document.getElementsByClassName("product-row"));

        rows.forEach((row) =>  {
            let kwh = parseFloat(row.dataset.kwh);

            if (kwh >= fromHandle && kwh <= toHandle) {
                row.style.display = "";
            } else {
                row.style.display = "none";
            }
        });

        this.kwhTextTarget.innerHTML = `${handles[0]}kWh - ${handles[1]}kWh`;
    }
}